import { AccountStore } from './account.store';
import { AppSettingStore } from './appSettings.store';
import { AuthStore } from './auth.store';
import { ClientSideTranslation } from './clientSideTranslation.store';
import { FeaturesStore } from './features.store';
import { LoyaltyProgramStore } from './loyaltyProgram.store';
import { NotificationsStore } from './notifications.store';
import { PopupModalStore } from './popupModal.store';
import { PSPStore } from './psp.store';
import { TradingAccountsStore } from './tradingAccounts.store';

export class MobxRootStore {
  authStore: AuthStore;
  accountStore: AccountStore;
  pspStore: PSPStore;
  notificationStore: NotificationsStore;
  appSettingStore: AppSettingStore;
  tradingAccountsStore: TradingAccountsStore;
  popupModalStore: PopupModalStore;
  featuresStore: FeaturesStore;
  loyaltyProgramStore: LoyaltyProgramStore;
  clientSideTranslationStore: ClientSideTranslation;

  constructor() {
    this.authStore = new AuthStore(this);
    this.accountStore = new AccountStore(this);
    this.pspStore = new PSPStore(this);
    this.notificationStore = new NotificationsStore(this);
    this.appSettingStore = new AppSettingStore(this);
    this.tradingAccountsStore = new TradingAccountsStore(this);
    this.popupModalStore = new PopupModalStore(this);
    this.featuresStore = new FeaturesStore(this);
    this.loyaltyProgramStore = new LoyaltyProgramStore(this);
    this.clientSideTranslationStore = new ClientSideTranslation(this);
  }
}

export const mobxStore = new MobxRootStore();
